import { RequisitesDetailsPage } from 'features/requisites';

export const TraderPayinRequisitesDetailsPage: React.FC = () => (
  <RequisitesDetailsPage />
);
